"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.TabsContext = void 0;
var _react = _interopRequireWildcard(require("react"));
var _lodash = require("lodash");
var _desktop = _interopRequireDefault(require("./desktop"));
var _mobile = _interopRequireDefault(require("./mobile"));
var _all = require("gsap/all");
var _styles = require("./styles");
var _utilities = require("./utilities");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function (nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
const TabsContext = (0, _react.createContext)();
exports.TabsContext = TabsContext;
const Tabs = ({
  sections,
  initTimelines
}) => {
  const pinRef = (0, _react.useRef)(null);
  const pinTlRef = (0, _react.useRef)();
  const [current, setCurrent] = (0, _react.useState)(null);
  const [mobile, setMobile] = (0, _react.useState)(false);
  const sectionTlsRef = (0, _react.useRef)([]);
  sectionTlsRef.current = Array(sections.length).fill().map((_, i) => sectionTlsRef.current[i] || (0, _react.createRef)());
  const scrollToSection = id => {
    _all.gsap.to(window, {
      scrollTo: document.querySelector(`#${id}`),
      duration: 0.45,
      ease: 'power2.easeInOut'
    });
  };
  const initSectionsTl = () => {
    const sectionHeights = (0, _utilities.calculateSectionHeights)(sections);
    (0, _lodash.forEach)(sections, (section, index) => {
      const s = document.querySelector(`#${section.id}`);
      const onToggle = self => {
        if (self.isActive) {
          setCurrent(index);
        }
      };
      if (s) {
        if (sectionTlsRef.current[index].current) {
          sectionTlsRef.current[index].current.kill();
        }
        sectionTlsRef.current[index].current = _all.gsap.to(section, {
          scrollTrigger: {
            trigger: s,
            start: 'top top+=80px',
            end: `+=${sectionHeights[index] - 80}px`,
            onToggle: onToggle
          }
        });
      }
    });
  };
  const initPinTl = () => {
    if (pinTlRef.current) {
      pinTlRef.current.kill();
    }
    const pinHeight = document.querySelector(`#${_utilities.CONTAINER_ID}`).offsetHeight - window.innerHeight;
    const scrollTriggerOptions = {
      trigger: pinRef.current,
      scrub: true,
      start: 'top top',
      end: `+=${pinHeight}px`,
      pin: true,
      pinSpacing: false
    };
    pinTlRef.current = _all.gsap.timeline().to(pinRef.current, {
      scrollTrigger: scrollTriggerOptions
    });
  };
  const resetMobile = () => {
    if (window.innerWidth < 768) {
      setMobile(true);
    }
    if (window.innerWidth >= 768) {
      setMobile(false);
    }
  };
  (0, _react.useEffect)(() => {
    if (initTimelines === true || typeof initTimelines === 'undefined') {
      setTimeout(() => {
        resetMobile();
        initPinTl();
        initSectionsTl();
      }, 250);
      const onResize = (0, _lodash.debounce)(() => {
        resetMobile();
        initPinTl();
        initSectionsTl();
      }, 150);
      window.addEventListener('resize', onResize);
      return () => {
        window.removeEventListener('resize', onResize);
      };
    }
  }, [initTimelines]);
  (0, _react.useEffect)(() => {
    return () => {
      if (pinTlRef.current) {
        pinTlRef.current.kill();
      }
    };
  }, []);
  return _react.default.createElement(TabsContext.Provider, {
    value: {
      current,
      scrollToSection
    }
  }, _react.default.createElement(_styles.TabsWrapper, {
    ref: pinRef
  }, !mobile && _react.default.createElement(_desktop.default, {
    sections: sections
  }), mobile && _react.default.createElement(_mobile.default, {
    sections: sections
  })));
};
var _default = Tabs;
exports.default = _default;
//# sourceMappingURL=index.js.map